var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke:#138de8;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-width:1.5px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.708 3.25)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M10.033,19.342a37.743,37.743,0,0,1-6.524-5.079A12.989,12.989,0,0,1,.4,9.312C-.761,5.688.6,1.539,4.41.311a6.476,6.476,0,0,1,5.877.99h0a6.486,6.486,0,0,1,5.877-.99c3.81,1.228,5.182,5.376,4.016,9a12.99,12.99,0,0,1-3.105,4.951,37.743,37.743,0,0,1-6.524,5.079L10.3,19.5Z",
    transform: "translate(0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M0,0A3.013,3.013,0,0,1,2.077,2.624",
    transform: "translate(14.343 4.391)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeart);
export default __webpack_public_path__ + "static/media/heart.faaaf25019d75716d1f8ac15b1626d9b.svg";
export { ForwardRef as ReactComponent };